import React from 'react';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';

export interface IMessageRequire {
  message?: string | null;
  classWrapper?: string;
  isWarning?: boolean;
  labelClass?: string;
  classMessage?: string;
  iconClass?: string;
}
export default function MessageError({
  message,
  classWrapper = 'ms-2',
  isWarning,
  labelClass = 'mt-1',
  classMessage = '',
  iconClass = '',
}: IMessageRequire): JSX.Element {
  if (message) {
    return (
      <div className={classWrapper}>
        <small
          className={`text-cherry d-flex align-items-center ${isWarning && 'text-dark-red'} ${
            labelClass ?? ''
          }`}
        >
          <ExclamationTriangleFill className={`${iconClass}`} />
          <span className={`d-block px-1 mw-600 ${classMessage}`}>{message}</span>
        </small>
      </div>
    );
  }
  return <></>;
}
